import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { patientNamespace } from "@/store/modules/patient";
import _ from "lodash";
import { Patient } from "@/store/modules/patient/types";

@Component({})
export default class PatientDetailOB extends Vue {
  @Getter("config", patientNamespace)
  config!: any;

  @Getter("caseState", patientNamespace)
  caseState!: any;

  @Prop(Object)
  data!: Patient;

  get ifNotPostPartum() {
    return this.currentCaseState.stage < 5;
  }

  get rupture() {
    const ruptureLegend = _.get(this, "data.body.atoms.rupture.legend", "");
    const [ruptureType, rupture] = ruptureLegend.split("|");
    return { ruptureType, rupture };
  }

  get hasEpidural() {
    return (
      _.get(this, "data.body.atoms.epidural.legend", "").indexOf("Yes") >= 0
    );
  }

  get laborOrEarlier() {
    return this.currentCaseState.stage <= 4;
  }

  get currentCaseState() {
    if (!this.caseState) {
      return { stage: 0, abbrev: "" };
    }
    const caseState = _.get(this, "data.census.caseState", {});
    const actualCaseState = this.caseState[caseState];
    return actualCaseState;
  }

  get gbs() {
    const age = _.get(this, "data.body.current.GBSPositive.age", 0);
    return age >= 0 &&
      _.get(this, "data.body.current.GBSPositive.value", 0) == 1
      ? "Pos"
      : "Neg";
  }

  get sensoryLevel() {
    const leftText = _.get(this, "data.body.current.SensoryLevelLeft.text", "");
    const rightText = _.get(
      this,
      "data.body.current.SensoryLevelRight.text",
      ""
    );
    return [leftText, rightText].filter(text => text !== "").join("-");
  }

  get sacral() {
    return _.get(this, "data.body.current.SacralCoverage.text", "");
  }
}
